<template>
  <v-container fluid class="pa-4">
    <!-- ====== Filters ====== -->
    <v-row dense>
        <v-col cols="6" sm="12">
            <v-card class="pa-4 mb-4 rounded-lg" elevation="2">
                <v-row dense justify="space-between">
                    <v-col cols="4" sm="4">
                        <v-date-input
                            input-format="dd/mm/yyyy"
                            v-model="filters.from_date"
                            label="From Date"
                            density="compact"
                            variant="outlined"
                            prepend-icon=""
                            prepend-inner-icon="mdi mdi-calendar-month"
                            single-line
                            bg-color="grey-lighten-4"
                            autocomplete="off"
                            hide-details
                        ></v-date-input>
                    </v-col>
                    <v-col cols="4" sm="4">
                        <v-date-input
                            input-format="dd/mm/yyyy"
                            v-model="filters.to_date"
                            label="To Date"
                            density="compact"
                            variant="outlined"
                            prepend-icon=""
                            prepend-inner-icon="mdi mdi-calendar-month"
                            single-line
                            bg-color="grey-lighten-4"
                            autocomplete="off"
                            hide-details
                        ></v-date-input>
                    </v-col>
                    <v-col cols="2" sm="2" class="d-flex align-center">
                        <v-btn color="primary" block @click="loadDashboard">
                            <v-icon left>mdi-magnify</v-icon> Filter
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card>
        </v-col>
    </v-row>

    <!-- ====== Summary Cards ====== -->
    <v-row dense>
      <v-col cols="3">
        <v-card class="pa-4 rounded-lg" elevation="2">
          <v-row align="center" justify="space-between">
            <v-col cols="7">
              <v-icon color="primary">mdi-chart-line-variant</v-icon>
              <div class="text-subtitle-2 text-grey-darken-1">
                  Lead
                </div>
                <div class="text-h5 font-weight-bold mt-1">
                  {{ summary.leads.current_count }}
                </div>
            </v-col>
            <v-col cols="5" class="d-flex align-center justify-end">
              <v-progress-circular
                :model-value="Math.abs(summary.leads.percentage_change)"
                size="70"
                width="5"
                :color="summary.leads.percentage_change >= 0 ? 'green-darken-2' : 'red-darken-2'"
                bg-color="grey-lighten-3"
              >
                <span class="text-body-2 font-weight-bold">
                  {{ summary.leads.percentage_change }}%
                </span>
              </v-progress-circular>
            </v-col>
          </v-row>
        </v-card>
      </v-col>

      <v-col cols="3">
        <v-card class="pa-4 rounded-lg" elevation="2">
          <v-row align="center" justify="space-between">
            <v-col cols="7">
              <v-icon color="primary">mdi-file-document</v-icon>
                <div class="text-subtitle-2 text-grey-darken-1">
                  Proposal
                </div>
                <div class="text-h5 font-weight-bold mt-1">
                  {{ summary.proposals.current_count }}
                </div>
            </v-col>
            <v-col cols="5" class="d-flex align-center justify-end">
              <v-progress-circular
                :model-value="Math.abs(summary.proposals.percentage_change)"
                size="70"
                width="5"
                :color="summary.proposals.percentage_change >= 0 ? 'green-darken-2' : 'red-darken-2'"
                bg-color="grey-lighten-3"
              >
                <span class="text-body-2 font-weight-bold">
                  {{ summary.proposals.percentage_change }}%
                </span>
              </v-progress-circular>
            </v-col>
          </v-row>
        </v-card>
      </v-col>

      <v-col cols="3">
        <v-card class="pa-4 rounded-lg" elevation="2">
          <v-row align="center" justify="space-between">
            <v-col cols="7">
              <v-icon color="primary">mdi-file-document</v-icon>
              <div class="text-subtitle-2 text-grey-darken-1">
                  Work Order
                </div>
                <div class="text-h5 font-weight-bold mt-1">
                  {{ summary.work_orders.current_count }}
                </div>
            </v-col>
            <v-col cols="5" class="d-flex align-center justify-end">
              <v-progress-circular
                :model-value="Math.abs(summary.work_orders.percentage_change)"
                size="70"
                width="5"
                :color="summary.work_orders.percentage_change >= 0 ? 'green-darken-2' : 'red-darken-2'"
                bg-color="grey-lighten-3"
              >
                <span class="text-body-2 font-weight-bold">
                  {{ summary.work_orders.percentage_change }}%
                </span>
              </v-progress-circular>
            </v-col>
          </v-row>
        </v-card>
      </v-col>

      <v-col cols="3">
        <v-card class="pa-4 rounded-lg bg-gray" elevation="2">
          <v-row align="center" justify="space-between">
            <v-col cols="7">
              <v-icon color="primary">mdi-file-document</v-icon>
                <div class="text-subtitle-2 text-grey-darken-1">
                  Sales Order
                </div>
                <div class="text-h5 font-weight-bold mt-1">
                  {{ summary.sale_orders.current_count }}
                </div>
            </v-col>
            <v-col cols="5" class="d-flex align-center justify-end">
              <v-progress-circular
                :model-value="Math.abs(summary.sale_orders.percentage_change)"
                size="70"
                width="5"
                :color="summary.sale_orders.percentage_change >= 0 ? 'green-darken-2' : 'red-darken-2'"
                bg-color="grey-lighten-3"
              >
                <span class="text-body-2 font-weight-bold">
                  {{ summary.sale_orders.percentage_change }}%
                </span>
              </v-progress-circular>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    
    </v-row>

    <v-row dense>
      <v-col cols="3">
        <v-card class="pa-4 rounded-lg d-flex bg-gray" elevation="2" style="min-height: 113px;">
        <v-row align="center" justify="space-between">
            <v-col>
              <v-icon color="primary">mdi-cash</v-icon>
              <div class="text-subtitle-2 text-grey-darken-1">Total Paid</div>
            </v-col>
            <v-col class="text-right">
              <v-chip color="success">
                  {{ summary.payments?.current_range.total_paid }}
              </v-chip>
            </v-col>
        </v-row>
        </v-card>
      </v-col>
      <v-col cols="3">
        <v-card class="pa-4 rounded-lg d-flex bg-gray" elevation="2" style="min-height: 113px;">
        <v-row align="center" justify="space-between">
          <v-col>
            <v-icon color="primary">mdi-credit-card-minus</v-icon>
            <div class="text-subtitle-2 text-grey-darken-1">Total Due</div>
          </v-col>
          <v-col class="text-right">
            <v-chip color="success">
              {{ summary.payments?.current_range.total_due }}
            </v-chip>
          </v-col>
        </v-row>
        </v-card>
      </v-col>
      <v-col cols="3">
        <v-card class="pa-4 rounded-lg d-flex bg-gray" elevation="2" style="min-height: 113px;">
        <v-row align="center" justify="space-between">
          <v-col>
            <v-icon color="primary">mdi-cash</v-icon>
            <div class="text-subtitle-2 text-grey-darken-1">Current Range Paid</div>
            </v-col>
            <v-col class="text-right">
              <v-chip color="success">
                {{ summary.payments?.current_range.total_paid }}
              </v-chip>
          </v-col>
        </v-row>
        </v-card>
      </v-col>
      <v-col cols="3">
        <v-card class="pa-4 rounded-lg d-flex" elevation="2" style="min-height: 113px;">
        <v-row align="center" justify="space-between">
          <v-col>
            <v-icon color="primary">mdi-credit-card-minus</v-icon>
            <div class="text-subtitle-2 text-grey-darken-1">Current Range Due</div>
          </v-col>
          <v-col class="text-right">
              <v-chip color="success">
                {{ summary.payments?.current_range.total_due }}
              </v-chip>
          </v-col>
        </v-row>
        </v-card>
      </v-col>
    </v-row>

    <!-- ====== My Sales Target ====== -->
    <v-card class="pa-4 mt-4 rounded-lg" elevation="2">
      <div class="text-subtitle-1 font-weight-bold mb-2">Sales Target</div>
      <v-progress-linear
        height="10"
        :model-value="summary.sale_target.achievement_percentage"
        color="black"
        background-color="grey-lighten-2"
        class="rounded-pill"
      ></v-progress-linear>
      <div class="d-flex justify-space-between mt-2">
        <div>{{ summary.sale_target.achievement_percentage.toFixed(0) }}%</div>
        <div>{{ summary.sale_target.target_amount.toLocaleString() }}</div>
      </div>
    </v-card>

    <!-- ====== Sales Target by Employee ====== -->
    <v-card class="pa-4 mt-4 rounded-lg" elevation="2">
      <div class="text-subtitle-1 font-weight-bold mb-3">Sales Target</div>

      <v-row
        v-for="(emp, i) in summary.employee_performance"
        :key="i"
        class="align-center mb-3"
      >
        <v-col cols="2">
          <v-avatar size="40">
            <v-img :src="baseURL + '/' + emp.employee_image" cover />
          </v-avatar>
        </v-col>

        <v-col cols="7">
          <div class="text-body-2 font-weight-bold">{{ emp.employee_name }} ({{ emp.target_percentage.toFixed(1) }}%)</div>
          <v-progress-linear
            height="8"
            :model-value="emp.target_percentage"
            color="black"
            background-color="grey-lighten-3"
            class="rounded-pill mt-1"
          ></v-progress-linear>
        </v-col>

        <v-col cols="3" class="text-right">
          <div class="text-body-2 font-weight-bold">{{ emp.sale_target.toLocaleString() }}</div>
        </v-col>
      </v-row>
    </v-card>

    <!-- ====== Top Performers ====== -->
    <v-card class="pa-4 mt-4 rounded-lg" elevation="2">
      <div class="text-subtitle-1 font-weight-bold mb-3">Top Performers</div>

      <v-slide-group show-arrows>
        <v-slide-group-item
          v-for="(emp, i) in summary.employee_performance.slice(0,5)"
          :key="i"
        >
          <v-card class="mx-2 pa-3 rounded-xl" width="150" color="amber-lighten-4">
            <v-avatar size="40" class="mb-2">
              <v-img :src="fileServerUrl + emp.employee_image" cover />
            </v-avatar>
            <div class="text-body-2 font-weight-bold">{{ emp.employee_name }}</div>
            <div class="text-caption grey--text">
              {{ emp.department_name }}, {{ emp.designation_name }}
            </div>
          </v-card>
        </v-slide-group-item>
      </v-slide-group>
    </v-card>

    <!-- ====== Sales Chart ====== -->
    <v-card class="pa-4 mt-4 rounded-lg" elevation="2">
      <div class="text-subtitle-1 font-weight-bold mb-3">Sales</div>
      <apexchart
        type="bar"
        height="250"
        :options="chartOptions"
        :series="chartSeries"
      />
    </v-card>
  </v-container>
</template>

<script setup>
import { ref, onMounted } from "vue";
import ApexChart from "vue3-apexcharts";
import axios from "axios";
import formattedDate from "@/plugins/dateFormatter";
import { fileServerUrl } from "@/store/api";

const filters = ref({
  from_date: "",
  to_date: "",
});

const summary = ref({
  leads: { current_count: 0, percentage_change: 0 },
  proposals: { current_count: 0, percentage_change: 0 },
  work_orders: { current_count: 0, percentage_change: 0 },
  sale_orders: { current_count: 0, percentage_change: 0 },
  sale_target: { target_amount: 0, achievement_percentage: 0 },
  employee_performance: [],
  sales_summary: {},
});
const baseURL = import.meta.env.VITE_API_BASE_URL || "";

const chartSeries = ref([
  {
    name: "Sales",
    data: [],
  },
]);
const chartOptions = ref({
  chart: { toolbar: { show: false } },
  xaxis: { categories: ["Today", "This Week", "This Range"] },
  colors: ["#3b82f6"],
  dataLabels: { enabled: false },
});

const loadDashboard = async () => {
    filters.value.from_date = formattedDate(filters.value.from_date);
    filters.value.to_date = formattedDate(filters.value.to_date);

  const res = await axios.get(
    `${baseURL}/auth/sales/get-sale-dashboard-summary`,
    { params: filters.value }
  );
  summary.value = res.data;


  chartSeries.value[0].data = [
    summary.value.sales_summary.today,
    summary.value.sales_summary.this_week,
    summary.value.sales_summary.current_range,
  ];

};

onMounted(async () => {
    loadDashboard();
});
</script>

<style scoped>
.text-h5 {
  line-height: 1.2;
}
</style>
